import { render } from "./index.vue?vue&type=template&id=2af1da10&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2af1da10&scoped=true&lang=css"

import exportComponent from "/Applications/phpstudy/bjhy/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2af1da10"]])

export default __exports__